module.exports = __webpack_public_path__ + "static/renta_fija-1d2eff80183ae38397ef8b1fbf31bef6.png";